module.exports = __webpack_public_path__ + "app/modals/reset-display-minutes.view.html";